var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChart3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 79,
    viewBox: "0 0 98 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.3901 25.0542V27.3441L49 44.2593V41.9694L90.3901 25.0542Z",
    fill: "#212122"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3901 58.88V61.17L49 44.2572V41.9673L90.3901 58.88Z",
    fill: "#212122"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9814 8.16553V10.4554L49.0005 44.2571V41.9672L48.9814 8.16553Z",
    fill: "#212122"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60059 58.8681V61.158L49.0002 44.2572V41.9673L7.60059 58.8681Z",
    fill: "#212122"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9902 8.16553C66.5883 8.16553 81.5836 14.2807 90.3899 25.0544V27.3443C81.586 16.5706 66.5883 10.453 48.9902 10.4554V8.16553Z",
    fill: "#212122"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5957 25.0737V27.3636L49.0001 44.2597V41.9698L7.5957 25.0737Z",
    fill: "#212122"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3901 25.0542V27.3441L49 44.2593V41.9694L90.3901 25.0542Z",
    fill: "#212122"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60036 58.8706C3.47342 54.2081 1.19547 48.1964 1.19629 41.9698V44.2597C1.19488 38.0352 3.47108 32.0254 7.59559 27.3636V25.0737C3.47108 29.7355 1.19488 35.7453 1.19629 41.9698V44.2597C1.19547 50.4863 3.47342 56.498 7.60036 61.1605V58.8706Z",
    fill: "#212122"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8033 41.9673C96.8039 48.1992 94.5224 54.2156 90.3896 58.88V61.17C94.5224 56.5055 96.8039 50.4891 96.8033 44.2572V41.9673Z",
    fill: "#212122"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60059 58.8681V61.158L49.0002 44.2572V41.9673L7.60059 58.8681Z",
    fill: "#212122"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3901 58.88V61.17L49 44.2572V41.9673L90.3901 58.88Z",
    fill: "#212122"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9907 75.7715C31.3926 75.7715 16.3996 69.6467 7.60059 58.8706V61.1605C16.3996 71.9366 31.3926 78.059 48.9907 78.0614V75.7715Z",
    fill: "#212122"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3899 58.8799C81.5861 69.6536 66.5883 75.7712 48.9902 75.7688V78.0587C66.5883 78.0587 81.5837 71.9435 90.3899 61.1698V58.8799Z",
    fill: "#212122"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9902 8.16553C66.5883 8.16553 81.5836 14.2807 90.3899 25.0544L48.9998 41.9696L48.9902 8.16553Z",
    fill: "#212122",
    stroke: "white",
    strokeWidth: 0.1,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3901 25.0542C99.2035 35.8375 99.2035 48.0965 90.3901 58.8798L49 41.967L90.3901 25.0542Z",
    fill: "#212122",
    stroke: "white",
    strokeWidth: 0.1,
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3899 58.88C81.5861 69.6538 66.5883 75.7714 48.9902 75.769V41.9673L90.3899 58.88Z",
    fill: "#212122",
    stroke: "white",
    strokeWidth: 0.1,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9907 75.769C31.3926 75.769 16.3996 69.6443 7.60059 58.8681L49.0002 41.9673L48.9907 75.769Z",
    fill: "#212122",
    stroke: "white",
    strokeWidth: 0.1,
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60018 58.8706C-1.19886 48.0945 -1.20125 35.8523 7.60018 25.0737L49.0046 41.9698L7.60018 58.8706Z",
    fill: "#212122",
    stroke: "white",
    strokeWidth: 0.1,
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M5.20703 17.9082V20.1981L46.6115 37.0942V34.8043L5.20703 17.9082Z",
    fill: "#4F0C84"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M5.20703 17.908C14.0037 7.12947 28.9943 1.00716 46.5924 1V3.2899C28.9943 3.2899 14.0037 9.41937 5.20703 20.1979V17.908Z",
    fill: "#4F0C84"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M5.20703 17.908C14.0037 7.12947 28.9943 1.00716 46.5924 1L46.6115 34.8017L5.20703 17.908Z",
    fill: "#4F0C84",
    stroke: "white",
    strokeWidth: 0.1,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart3);
export default __webpack_public_path__ + "static/media/Chart3.b96ad19449d7995b6d413d53d303a5ff.svg";
export { ForwardRef as ReactComponent };